{
  "template": {
    "section": "Sườn nhận xét",
    "meta": {
      "preset": "Từ preset {{preset}}, đã chỉnh · {{count}} mục",
      "presetPristine": "Preset {{preset}} · {{count}} mục",
      "custom": "Tự tạo · {{count}} mục"
    },
    "edit": "Sửa sườn",
    "applyNote": "Áp dụng cho mọi suất {{subject}} từ buổi tiếp theo. Ghi chú đã lưu không đổi.",
    "group": {
      "class": "Nhận xét cả lớp",
      "student": "Riêng từng học viên",
      "homework": "Bài về nhà",
      "emptyRow": "Chưa có mục nào. Nhóm này sẽ ẩn trong form nhận xét."
    },
    "empty": {
      "body": "Chưa có sườn. Form nhận xét buổi đang là ô trống tự do. Chọn một sườn để giáo viên viết nhanh và đều tay hơn: mỗi mục thành một ô riêng, ai cũng ghi cùng những điều.",
      "hint": "Chọn xong vẫn sửa được từng mục trước khi lưu."
    },
    "preset": {
      "music": "Âm nhạc",
      "art": "Mĩ thuật",
      "exam": "Luyện thi",
      "custom": "Tự tạo từ đầu",
      "customSub": "Bắt đầu với ba nhóm trống"
    },
    "editor": {
      "title": "Sườn nhận xét · {{subject}}",
      "desc": "Mỗi mục thành một ô trong form nhận xét buổi. Gợi ý hiện làm placeholder, giáo viên không phải điền hết.",
      "descPreset": "Preset {{preset}}. Sửa tên mục và gợi ý cho hợp lớp mình rồi lưu."
    },
    "item": {
      "namePh": "Tên mục",
      "hintPh": "Gợi ý cho giáo viên (không bắt buộc)",
      "add": "Thêm mục",
      "remove": "Xoá mục",
      "drag": "Kéo để đổi thứ tự"
    },
    "count": "{{count}} mục",
    "resetToPreset": "Về preset {{preset}}",
    "resetTitle": "Về preset {{preset}}?",
    "resetBody": "Các mục bạn đã sửa sẽ thay bằng bộ gốc.",
    "resetConfirm": "Về preset",
    "resetCancel": "Giữ như đang sửa",
    "save": "Lưu sườn",
    "savedToast": "Đã lưu sườn nhận xét môn {{subject}}",
    "remove": "Bỏ sườn",
    "removeTitle": "Bỏ sườn nhận xét môn {{subject}}?",
    "removeBody": "Form nhận xét buổi quay về ô trống tự do từ buổi tiếp theo. Ghi chú đã lưu không đổi.",
    "removeConfirm": "Bỏ sườn",
    "removeCancel": "Giữ sườn",
    "rating": {
      "label": "Chấm mức buổi học",
      "desc": "Giáo viên chọn một trong năm mức cho từng học viên mỗi buổi: Báo động, Cần chú ý, Khá, Tốt, Xuất sắc. Lên sổ liên lạc kèm tổng kết tháng, AI dùng khi viết nhận xét tháng.",
      "on": "Đang bật",
      "off": "Đang tắt",
      "savedOn": "Đã bật chấm mức buổi học",
      "savedOff": "Đã tắt chấm mức buổi học"
    }
  },
  "notes": {
    "entry": {
      "title": "Nhận xét buổi học",
      "empty": "Chưa có. Ghi vài dòng khi lớp vừa xong, cả lớp hoặc riêng từng học viên.",
      "summaryClass": "Cả lớp",
      "summaryStudents": "riêng {{count}} học viên",
      "summaryHomework": "BTVN chung",
      "edit": "Sửa"
    },
    "header": {
      "meta": "{{subject}} · {{day}} · {{roster}} học viên, {{present}} có mặt · Điền mục nào cũng được"
    },
    "templateHint": {
      "text": "Môn này chưa có sườn nhận xét.",
      "cta": "Tạo sườn",
      "dismiss": "Ẩn gợi ý này"
    },
    "class": {
      "label": "Cả lớp",
      "comment": "Nhận xét chung",
      "commentPh": "Hôm nay lớp học gì, làm được gì, cần lưu ý gì…",
      "homework": "Bài tập về nhà chung",
      "copyDown": "Chép nội dung này xuống từng học viên",
      "copiedToast": "Đã chép xuống {{count}} học viên",
      "collapse": "Thu gọn",
      "expand": "Mở ra",
      "commentHint": "Lên sổ liên lạc cả lớp, AI dùng cho học viên có mặt hoặc có phép"
    },
    "homework": {
      "common": "Bài về nhà chung",
      "personal": "Bài về nhà riêng",
      "personalHint": "Để trống nếu chỉ giao bài chung. Cũng lên sổ và nháp AI",
      "freeHint": "Cũng lên sổ và nháp AI"
    },
    "extra": {
      "add": "Ghi chú ngoài sườn",
      "label": "Ghi chú thêm",
      "homework": "Bài về nhà khác"
    },
    "student": {
      "label": "Riêng từng học viên",
      "hint": "Bấm tên để viết",
      "hintCount": "{{count}} học viên có dòng riêng",
      "comment": "Nhận xét riêng cho {{name}}",
      "commentPh": "Điều riêng của {{name}} hôm nay…",
      "homework": "Bài tập riêng",
      "homeworkPh": "Để trống nếu chỉ làm bài chung",
      "items": "Nhận xét",
      "itemsHint": "Lên sổ liên lạc, AI dùng khi viết nhận xét tháng",
      "rating": "Mức buổi học",
      "ratingHint": "Không bắt buộc. Bấm lại để bỏ chọn.",
      "ratingClear": "Bỏ chọn"
    },
    "openFor": "Nhận xét riêng cho {{name}}",
    "cancel": "Huỷ",
    "save": "Lưu nhận xét",
    "savedToast": "Đã lưu nhận xét buổi {{date}}",
    "discardTitle": "Bỏ nội dung vừa viết?",
    "discardBody": "Nội dung chưa lưu sẽ mất.",
    "discardConfirm": "Bỏ",
    "discardCancel": "Viết tiếp",
    "item": {
      "orphan": "Mục này đã bỏ khỏi sườn; nội dung cũ vẫn giữ"
    },
    "photos": {
      "add": "Thêm ảnh",
      "dropTitle": "Kéo thả ảnh vào đây hoặc <1>chọn ảnh</1>",
      "dropHint": "Nhiều ảnh cùng lúc · tối đa {{max}} ảnh · JPG, PNG",
      "dismiss": "Bỏ thêm ảnh",
      "remove": "Xoá ảnh",
      "uploading": "Đang tải ảnh",
      "more": "+{{n}}",
      "count": "{{n}} ảnh",
      "limitToast": "Tối đa {{max}} ảnh cho một phần bài về nhà",
      "failToast": "{{name}} không tải được: {{reason}}",
      "reason": {
        "heic": "định dạng HEIC, hãy chọn JPG hoặc PNG",
        "notImage": "không phải ảnh",
        "tooLarge": "quá {{max}} MB",
        "upload": "tải lên thất bại, thử lại"
      },
      "locked": "Ảnh bài về nhà có từ gói Pro"
    }
  },
  "review": {
    "title": "Nhận xét tháng {{month}}",
    "progress": "{{done}}/{{total}} đã viết",
    "filter": {
      "todo": "Chưa viết",
      "all": "Tất cả",
      "drafts": "Chờ duyệt"
    },
    "doneGroup": "Đã viết",
    "aiDrafted": "Nháp AI, đã chỉnh",
    "manual": "Tự viết",
    "noteMetaNoNotes": "{{sessions}} buổi · chưa có ghi chú",
    "emptySelect": "Chọn một học viên ở danh sách bên trái để viết nhận xét.",
    "loadError": "Không tải được danh sách nhận xét tháng. Thử lại sau.",
    "noteMeta": "{{sessions}} buổi · {{notes}} ghi chú",
    "panelMeta": "{{subject}} · Tháng {{month}} · {{sessions}} buổi: {{present}} có mặt, {{excused}} có phép, {{absent}} vắng",
    "position": "Học viên {{index}}/{{total}}",
    "profileLink": "Hồ sơ học viên",
    "noNotesBox": "Chưa có ghi chú buổi học nào của {{name}} trong tháng {{month}}. Học viên đi {{sessions}} buổi: {{present}} có mặt, {{absent}} vắng. Bạn có thể viết nhận xét dựa trên trí nhớ, hoặc bỏ qua học viên này.",
    "classPrefix": "Cả lớp:",
    "absentDay": "Vắng.",
    "ai": {
      "button": "AI viết nháp",
      "busy": "Đang viết…",
      "helperEnabled": "Tóm tắt từ {{count}} ghi chú trong tháng · 1 credit AI",
      "helperDisabled": "Chưa có ghi chú buổi nào để AI tóm tắt. Ghi chú sau mỗi buổi thì tháng sau AI viết được nháp.",
      "banner": "Nháp do AI tóm từ {{count}} ghi chú tháng {{month}}. Bạn đọc lại, sửa cho đúng giọng mình rồi mới lưu.",
      "redo": "Viết lại nháp",
      "clear": "Xoá, tự viết",
      "quota": "Hết credit AI tháng này. Bạn vẫn tự viết được, hoặc mua thêm credit.",
      "failedToast": "Chưa tạo được nháp, credit vẫn tính theo lượt thử. Bấm lại để thử lần nữa.",
      "replaceTitle": "Thay nội dung đang viết bằng nháp AI?",
      "replaceConfirm": "Thay",
      "replaceCancel": "Giữ"
    },
    "editorPh": "Vài dòng gửi phụ huynh {{name}}: tháng này em học gì, tiến bộ ở đâu, cần rèn thêm gì…",
    "editorHint": "Phụ huynh sẽ đọc nguyên văn trên sổ liên lạc và phiếu học phí tháng {{nextMonth}}. Tránh viết tắt nội bộ.",
    "credits": "Credit AI còn {{count}}",
    "save": "Lưu",
    "saveNext": "Lưu và sang học viên tiếp",
    "skip": "Bỏ qua",
    "allDone": "Đã viết xong {{total}}/{{total}} học viên",
    "savedToast": "Đã lưu nhận xét tháng {{month}} cho {{name}}",
    "entryButton": "Nhận xét tháng {{month}}",
    "attentionCard": "Nhận xét tháng {{month}} · {{subject}} · {{done}}/{{total}} đã viết",
    "attentionCardMore": "Nhận xét tháng {{month}} · còn {{count}} môn, {{done}}/{{total}} đã viết",
    "written": "Đã viết",
    "notWritten": "Chưa viết",
    "subtitle": "{{subject}} · {{count}} học viên · {{done}}/{{total}} đã viết · Viết xong sẽ hiện trên sổ liên lạc và phiếu học phí tháng {{nextMonth}}",
    "subtitlePhone": "{{done}}/{{total}} đã viết · hiện trên sổ liên lạc và phiếu tháng {{nextMonth}}",
    "notesHeading": "Ghi chú trong tháng",
    "writing": "đang viết",
    "startFirst": "Bắt đầu từ học viên đầu tiên",
    "monthPickerLabel": "Chọn tháng nhận xét",
    "moreSlots": "+{{count}} suất khác",
    "draftGroup": "Nháp chờ duyệt",
    "draftMeta": "Nháp AI, chưa duyệt",
    "draftTag": "Nháp chờ duyệt",
    "draftNotice": "Nháp AI, phụ huynh chưa thấy. Đọc lại, sửa cho đúng giọng mình rồi bấm Duyệt.",
    "saveDraft": "Lưu nháp",
    "approve": "Duyệt",
    "approveNext": "Duyệt và sang học viên tiếp",
    "approveNextShort": "Duyệt và sang em tiếp",
    "draftSavedToast": "Đã lưu nháp cho {{name}}, phụ huynh chưa thấy",
    "publishAll": "Duyệt cả {{count}} nháp",
    "publishAllTitle": "Duyệt cả {{count}} nháp?",
    "publishAllBody": "{{count}} nhận xét sẽ hiện trên sổ liên lạc và phiếu học phí tháng {{nextMonth}}, đúng nguyên văn nháp đang lưu. Nháp nào chưa đọc thì nên mở ra đọc trước.",
    "publishAllConfirm": "Duyệt tất cả",
    "publishAllCancel": "Để tôi đọc từng em",
    "publishAllToast": "Đã duyệt {{count}} nhận xét",
    "batch": {
      "button": "AI soạn nháp cho {{count}} em",
      "confirmTitle": "Soạn nháp AI cho {{count}} em?",
      "confirmBody": "Dùng {{count}} credit AI, hiện còn {{left}}. Nháp chưa hiện cho phụ huynh, bạn duyệt từng em hoặc duyệt cả loạt sau. Cần để mở trang này trong lúc chạy.",
      "confirmBodyShort": "Cần {{count}} credit AI nhưng chỉ còn {{left}}: sẽ soạn tới khi hết credit rồi dừng. Nháp chưa hiện cho phụ huynh. Cần để mở trang này trong lúc chạy.",
      "confirmBodyNoMeter": "Mỗi em tốn 1 credit AI, tổng {{count}}. Nháp chưa hiện cho phụ huynh, bạn duyệt từng em hoặc duyệt cả loạt sau. Cần để mở trang này trong lúc chạy.",
      "confirm": "Soạn nháp",
      "cancel": "Thôi",
      "progress": "Đang soạn nháp {{done}}/{{total}}",
      "stop": "Dừng",
      "doneToast": "Đã soạn {{count}} nháp, chờ bạn duyệt",
      "partialToast": "Soạn được {{done}} nháp, {{failed}} em lỗi. Bấm lại để chạy tiếp phần còn thiếu.",
      "quotaToast": "Hết credit AI sau {{done}} nháp. Phần còn lại bạn tự viết hoặc mua thêm credit.",
      "stopping": "Đang dừng, chờ các em đang soạn dở…",
      "skippedToast": "Không soạn thêm được em nào: {{count}} em đã có nhận xét hoặc chưa có ghi chú bằng chữ."
    }
  },
  "progress": {
    "tab": "Tiến độ học tập",
    "profileTab": "Hồ sơ",
    "monthMeta": "{{sessions}} buổi · {{present}} có mặt · {{excused}} có phép · {{absent}} vắng · {{notes}} ghi chú",
    "writeReview": "Viết nhận xét tháng {{month}}",
    "editReview": "Sửa",
    "reviewHeading": "Nhận xét tháng · {{subject}}",
    "reviewMeta": "{{teacher}} · {{date}}",
    "classChip": "Cả lớp",
    "loadMore": "Xem tháng {{month}} và trước đó",
    "asideReviews": "Nhận xét tháng",
    "asideWrite": "Viết",
    "emptyTitle": "Chưa có ghi chú nào về {{name}}",
    "emptyBody": "Sau mỗi buổi dạy, mở suất học và bấm \"Nhận xét buổi học\". Ghi chú sẽ tự gom về đây theo tháng, để giáo viên khác đọc là hiểu học viên ngay và cuối tháng có sẵn chất liệu viết nhận xét.",
    "emptyCta": "Mở suất học hôm nay",
    "monthTitle": "Tháng {{month}}",
    "asideShowAll": "Xem tất cả",
    "legacyFree": "Viết trước khi môn có sườn",
    "homeworkLabel": "BTVN"
  },
  "link": {
    "title": "Sổ liên lạc",
    "open": "Đang mở",
    "descCreated": "Phụ huynh mở bằng link, không cần tài khoản. Thấy điểm danh, ghi chú buổi học và nhận xét tháng của {{name}}.",
    "descNew": "Một link riêng cho phụ huynh của {{name}}: điểm danh theo tháng, ghi chú buổi học và nhận xét tháng. Không cần tài khoản, chỉ ai có link mới xem được.",
    "create": "Tạo link sổ liên lạc",
    "copy": "Chép link",
    "copied": "Đã chép link sổ liên lạc của {{name}}",
    "copyFailed": "Chưa chép được link, bạn chép tay giúp nhé.",
    "hint": "Dán vào tin Zalo cho phụ huynh, một lần là đủ. Nhắc họ bấm Cài app để lần sau mở nhanh.",
    "openPage": "Mở trang phụ huynh",
    "regenerate": "Tạo link mới",
    "regenTitle": "Tạo link sổ liên lạc mới?",
    "regenBody": "Link cũ sẽ ngừng hoạt động ngay. Phụ huynh đang giữ link cũ sẽ thấy trang không tồn tại, bạn cần gửi lại link mới cho họ. Ghi chú và nhận xét không bị ảnh hưởng.",
    "regenConfirm": "Tạo link mới, huỷ link cũ",
    "regenCancel": "Giữ link hiện tại",
    "proTitle": "Sổ liên lạc có từ gói Pro",
    "proBody": "Ghi chú và nhận xét bạn đang viết vẫn được lưu đầy đủ. Lên Pro để gửi phụ huynh một link xem điểm danh, ghi chú và nhận xét tháng của {{name}}, không cần tài khoản.",
    "proCta": "Xem gói Pro",
    "sample": "Xem trang mẫu",
    "bulkCreate": "Tạo link sổ liên lạc",
    "bulkConfirmTitle": "Tạo link sổ liên lạc?",
    "bulkConfirmBody": "Sẽ tạo link cho {{missing}} học viên chưa có, {{existing}} học viên đã có giữ nguyên.",
    "bulkAllLinked": "Tất cả học viên đang học đã có link phụ huynh.",
    "bulkConfirmAction": "Tạo link",
    "bulkConfirmCancel": "Huỷ",
    "bulkCreatedToast": "Đã tạo link cho {{count}} học viên",
    "bulkPrompt": "{{count}} học viên chưa có link sổ liên lạc",
    "bulkPromptAction": "Tạo ngay",
    "bulkButton": "Link sổ liên lạc",
    "hint2": "Menu ⋯ có \"Tạo link mới\" (link cũ ngừng ngay)."
  },
  "switcher": {
    "prev": "Tháng trước",
    "next": "Tháng sau"
  },
  "monthlyReviewsIndex": {
    "title": "Nhận xét tháng",
    "totalLine": "{{done}}/{{total}} học viên đã viết nhận xét",
    "writeMore": "Viết tiếp",
    "viewDone": "Xem",
    "doneLabel": "Đã viết",
    "noNotes": "{{count}} học viên chưa có ghi chú buổi",
    "emptyTitle": "Chưa có môn nào cần nhận xét tháng {{month}}",
    "emptyBody": "Khi có buổi học được xếp trong tháng, môn đó sẽ hiện ở đây để viết nhận xét.",
    "loadError": "Không tải được danh sách nhận xét tháng. Thử lại sau.",
    "drafts": "{{count}} nháp chờ duyệt"
  },
  "lightbox": {
    "download": "Tải ảnh",
    "close": "Đóng",
    "homework": "Bài tập về nhà",
    "common": "Bài chung",
    "personal": "Riêng {{name}}",
    "counter": "{{i}} / {{n}}"
  }
}
